<template>
  <div class="cmp-nav">
    <el-carousel :interval="5000" id="el-carousel" ref="carousel">
      <el-carousel-item>
        <img alt class="banner" src="@image/banner.jpg" />
      </el-carousel-item>
      <el-carousel-item>
        <img alt class="banner" src="@image/banner1.png" />
      </el-carousel-item>
      <el-carousel-item>
        <img alt class="banner" src="@image/banner2.png" />
      </el-carousel-item>
      <el-carousel-item>
        <img alt class="banner" src="@image/banner3.png" />
      </el-carousel-item>
    </el-carousel>
    <!-- <div class="middle" ref="middle">
      <p class="mb-20">湖北品农商用车服务有限公司</p>
      <h1>中国商用车融资服务领航者</h1>
    </div>-->
    <div class="cmp-header">
      <div class="flex-box">
        <div class="imgs">
          <img
            alt
            class="gray"
            height="41px"
            src="@image/city.png"
            width="36px"
          />
        </div>
        <div>
          <span class="num">
            <!-- {{
            ylStatus ? homeYlData.city : homeData.city
          }} -->
            {{ homeData.city }}
            <!-- {{ homeData.city }} -->
          </span>
          <span>省市</span>
        </div>
        <div class="tit">服务范围</div>
      </div>
      <div class="boder-line"></div>

      <div class="flex-box">
        <div>
          <img
            alt
            class="gray"
            height="39px"
            src="@image/money.png"
            width="39px"
          />
        </div>
        <div>
          <!-- <span class="num">1</span> -->
          <span>平安银行</span>
        </div>
        <div class="tit">唯一银行</div>
      </div>
      <div class="boder-line"></div>
      <div class="flex-box">
        <div>
          <img
            alt
            class="gray"
            height="34px"
            src="@image/tool.png"
            width="42px"
          />
        </div>
        <div>
          <span class="num">
            <!-- {{
            ylStatus ? homeYlData.plant : homeData.plant
          }} -->
            {{ homeData.plant }}
          </span>
          <span>家</span>
        </div>
        <div class="tit">合作厂家</div>
      </div>
      <div class="boder-line"></div>
      <div class="flex-box">
        <div>
          <img
            alt
            class="gray"
            height="41px"
            src="@image/stroe.png"
            width="42px"
          />
        </div>
        <div>
          <span class="num">
            <!-- {{
            ylStatus ? homeYlData.saleNum : homeData.saleNum
          }} -->
            {{ homeData.saleNum }}
          </span>
          <span>家</span>
        </div>
        <div class="tit">合作经销商</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getHome } from '@/api/home'
import { setTimeout } from 'timers'
export default {
  name: 'NavHeader',
  data() {
    return {
      bannerHeight: 700,
      screenWidth: 1920,
      isActive: false,
      ylStatus: this.$store.getters.urlStatus
    }
  },

  computed: {
    homeData() {
      let data = this.$store.getters.homeData
      let num = {}
      if (data) {
        for (const key in data) {
          switch (data[key].sign) {
            case 'syhzcj':
              num.plant = data[key].content
              break
            case 'syhzjxs':
              num.saleNum = data[key].content
              break
            case 'sysssl':
              num.city = data[key].content
              break
          }
        }
      }
      return num
    }
    // homeYlData() {
    //   let data = this.$store.getters.homeIndex
    //   let num = {}
    //   if (data) {
    //     for (const key in data) {
    //       switch (data[key].code) {
    //         case 'hzcj':
    //           num.plant = data[key].content
    //           break
    //         case 'hzjxs':
    //           num.saleNum = data[key].content
    //           break
    //         case 'sssl':
    //           num.city = data[key].content
    //           break
    //       }
    //     }
    //   }
    //   return num
    // }
  },
  mounted() {
    sessionStorage.setItem('bannerHeight', this.$refs.carousel.$el.clientHeight)
  },
  methods: {
    //合作经销商数量
    init() {
      // this.$http.post('/getSaleNum').then(res => {
      //   if (res.data.code) {
      //     this.saleNum = res.data.data
      //   }
      // })
    }
  }
}
</script>

<style lang="scss">
.cmp-nav {
  position: relative;
  margin-top: -62px;
  background: #f9faff;

  .cmp-header {
    position: absolute;
    bottom: -16%;
    left: 10%;
    display: flex;
    width: 80%;
    z-index: 100;
    justify-content: space-around;
    text-align: center;
    align-items: center;
    background: #fff;
    margin: auto;
    box-shadow: 0px 8px 46px 4px rgba(207, 207, 207, 0.3);
    .boder-line {
      width: 1px;
      height: 70px;
      background: rgba(236, 236, 236, 1);
    }
    .flex-box {
      padding: 30px;
      width: 300px;
      div {
        margin-bottom: 10px;
      }

      span {
        font-size: 18px;
        font-weight: 400;
        color: rgba(48, 48, 48, 1);
      }
      .num {
        font-size: 25px;
        font-weight: 500;
        margin-right: 5px;
      }
      .tit {
        font-size: 16px;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
      }
    }
  }
  // .middle {
  //   position: absolute;
  //   left: 0;
  //   right: 0;
  //   // bottom: 35%;
  //   bottom: 45%;
  //   width: 50%;
  //   margin: 0 auto;
  //   z-index: 99;
  //   text-align: center;
  //   h1 {
  //     font-size: 45px;
  //     font-weight: 500;
  //     letter-spacing: 10px;
  //   }
  //   p {
  //     color: #fff;
  //     font-size: 22px;
  //     letter-spacing: 12px;
  //     // font-family: monospace;
  //     opacity: 0.9;
  //   }
  //   .mt-30 {
  //     .el-button {
  //       padding: 10px 40px;
  //     }
  //   }
  // }
  .el-carousel {
    width: 100%;
    .header {
      border-bottom: 1px solid rgba(13, 26, 106, 0.15);
    }
    .el-carousel__indicators--outside button {
      background: #2a78ec;
    }
    .el-row {
      z-index: 99;
      .el-col {
        min-height: 60px;
        .grid-content {
          line-height: 60px;
          img {
            width: 181px;
            height: 34px;
          }
        }
      }
      .tel {
        line-height: 60px;
        color: #fff;
        text-align: start;
        img {
          vertical-align: middle;
          margin-right: 10px;
        }
      }
    }

    /deep/ .el-carousel__item--card {
      width: auto !important;
    }
    /deep/ .el-carousel__item {
      width: auto !important;
      padding-bottom: 50%;
    }
    /deep/ .el-carousel__item--card.is-active {
      z-index: 2;
      position: absolute;
      left: 50%;
    }

    .el-carousel__indicators--horizontal {
      bottom: 21%;
    }
    .el-carousel__container {
      padding-bottom: 35%;
      height: 100% !important;
      overflow: hidden;
    }
    .el-carousel__item:nth-child(1) {
      .middle {
        display: none;
      }
    }
    .banner {
      width: 100%;
      background-position: center center;
      background-repeat: no-repeat;
      -webkit-background-size: cover;
      -moz-background-size: cover;
      background-size: cover;
      animation: scale_b 25s linear infinite alternate;
    }
    @-webkit-keyframes scale_b {
      0% {
        transform: scale(1);
      }
      50% {
        transform: scale(1.25);
      }
      100% {
        transform: scale(1.5);
      }
    }
  }
  // .el-carousel__item.is-animating {
  //   transform: scale(1.5);
  //   transition: all 0.2s ease-in 0s;
  // }
  .gray {
    animation: circle 1.5s linear 0s;
  }

  /*关键帧动画*/
  @-webkit-keyframes circle {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
}
</style>
